__turbopack_context__.v({
  "blocksBackgroundColor": "VideoBlock-module-scss-module__eJzP7a__blocksBackgroundColor",
  "blocksFontColor": "VideoBlock-module-scss-module__eJzP7a__blocksFontColor",
  "embedFullHeight": "VideoBlock-module-scss-module__eJzP7a__embedFullHeight" + " " + "VideoBlock-module-scss-module__eJzP7a__embedResponsive",
  "embedResponsive": "VideoBlock-module-scss-module__eJzP7a__embedResponsive",
  "embedResponsive16by9": "VideoBlock-module-scss-module__eJzP7a__embedResponsive16by9",
  "embedResponsive4by3": "VideoBlock-module-scss-module__eJzP7a__embedResponsive4by3",
  "embedResponsiveItem": "VideoBlock-module-scss-module__eJzP7a__embedResponsiveItem",
  "secondaryNavBackgroundColor": "VideoBlock-module-scss-module__eJzP7a__secondaryNavBackgroundColor",
  "themeBackgroundColor": "VideoBlock-module-scss-module__eJzP7a__themeBackgroundColor",
  "themeFontColor": "VideoBlock-module-scss-module__eJzP7a__themeFontColor",
  "themeFontFamily": "VideoBlock-module-scss-module__eJzP7a__themeFontFamily",
});
